export default "__VITE_ASSET__CUnUukk1__"